/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Simple function to update cart total price displays
const updateCartTotalPrice = (cartData) => {
  // Handle empty cart case
  if (!cartData || cartData.item_count === 0) {
    const priceElement = document.querySelector("[data-cart-total-price]");
    if (priceElement) {
      priceElement.textContent = "$0.00";
    }
    return;
  }

  if (!cartData.total_price) {
    return;
  }

  // Format the price (convert from cents to dollars)
  const formattedPrice = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(cartData.total_price / 100);

  // Update the navbar cart total price
  const priceElement = document.querySelector("[data-cart-total-price]");
  if (priceElement) {
    priceElement.textContent = formattedPrice;
  }
};

function checkToAnimateCartGoal(oldCartGoal, newCartGoal) {
  if (oldCartGoal && newCartGoal) {
    const currentLevel = parseInt(oldCartGoal.dataset.activeLevel) || 0;
    const newLevel = parseInt(newCartGoal.dataset.activeLevel) || 0;

    if (newLevel > currentLevel) {
      // Get the celebrating marker and animate it
      const celebratingMarker = newCartGoal.querySelector(".cart-goal-marker.celebrating");
      if (celebratingMarker) {
        createConfettiEffect(celebratingMarker);
      }
    }
  }
}

// Refresh cart contents (offcanvas cart, cart page, count badges, etc)
window.refreshCartContents = async (response) => {
  const offcanvasCart = document.querySelector("#offcanvas-cart");

  offcanvasCart?.classList.add("loading");

  const newResponse = await fetch(window.location.href);
  const text = await newResponse.text();
  const newDocument = new DOMParser().parseFromString(text, "text/html");

  const topCartGoal = document.querySelector("#topbar .cart-goal");
  const newTopCartGoal = newDocument.querySelector("#topbar .cart-goal");
  checkToAnimateCartGoal(topCartGoal, newTopCartGoal);
  topCartGoal?.replaceWith(newTopCartGoal);

  const slideCartGoal = document.querySelector("#offcanvas-cart .cart-goal");
  const newSlideCartGoal = newDocument.querySelector("#offcanvas-cart .cart-goal");
  checkToAnimateCartGoal(slideCartGoal, newSlideCartGoal);
  slideCartGoal?.replaceWith(newSlideCartGoal);

  document.querySelectorAll(".cart-count-badge").forEach((badge) => {
    badge.textContent = newDocument.querySelector(".cart-count-badge").textContent;
    badge.removeAttribute("tw:hidden");
  });

  offcanvasCart?.classList.remove("loading");

  window.dispatchEvent(new Event("updated.ecomify.cart"));

  if (!response) {
    offcanvasCart?.querySelector("#offcanvas-cart-alert-updated").removeAttribute("tw:hidden");
  } else {
    if (response.ok) {
      if (response.url.includes("add.js")) {
        // offcanvasCart?.querySelector('#offcanvas-cart-alert-add').removeAttribute('hidden')
        // const data = await response.json()
        // if (data.items?.length > 1) {
        //     const elemAlertItemsAdded = offcanvasCart?.querySelector('#offcanvas-cart-alert-add [data-alert-items-added]')
        //     elemAlertItemsAdded.textContent = elemAlertItemsAdded.textContent.replace('[count]', data.items.length)
        //     elemAlertItemsAdded.removeAttribute('hidden')
        // } else {
        //     offcanvasCart?.querySelector('#offcanvas-cart-alert-add [data-alert-item-added]')
        //         .removeAttribute('hidden')
        // }
      } else {
        offcanvasCart?.querySelector("#offcanvas-cart-alert-updated").removeAttribute("hidden");
      }
    } else {
      const data = await response.json();
      const alert = document.querySelector("#offcanvas-cart-alert-error");
      alert.querySelector("span").textContent = `${data.message} - ${data.description}`;
      alert.removeAttribute("hidden");
    }
  }
};

// Quantity Inputs
window.onChangeCartQty = async (input) => {
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: input.dataset.lineItemKey,
      quantity: input.value,
    }),
  });
  window.refreshCartContents(response);
};

// Remove Buttons
window.onRemoveCartItem = async (btn) => {
  if (btn.dataset.isGiftBoxParent === "true") {
    const updates = {};

    updates[btn.dataset.lineItemKey] = 0;

    btn
      .closest(".product-item")
      .querySelectorAll(".list-item-child-product-item")
      .forEach((elem) => {
        updates[elem.dataset.lineItemKey] = 0;
      });

    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    });
    window.refreshCartContents(response);
  } else {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: btn.dataset.lineItemKey,
        quantity: 0,
      }),
    });
    window.refreshCartContents(response);
  }
};

const setCartButtonState = (id, active, text) => {
  const cartButton = document.querySelector(id);
  console.log(cartButton);
  if (text) cartButton.querySelector("span").textContent = text;
  if (active) {
    cartButton.querySelector("span").classList.remove("d-none");
    cartButton.querySelector("svg").classList.add("d-none");
  } else {
    cartButton.querySelector("span").classList.add("d-none");
    cartButton.querySelector("svg").classList.remove("d-none");
  }
};
const setCartNoteButtonState = (active) => setCartButtonState("#btn-cart-note-modal", active, null);
const setCartDateButtonState = (active, text) => setCartButtonState("#btn-cart-date-modal", active, text);

// Cart Goal - Animate width
const initCartGoal = () => {
  const progressBars = document.querySelectorAll(".cart-goal .progress-bar");
  console.log(progressBars);
  progressBars.forEach((progressBar) => {
    setTimeout(() => {
      progressBar.style.width = progressBar.dataset.width;
    }, 250);
  });
};
initCartGoal();

window.addEventListener("updated.ecomify.cart", () => {
  initCartGoal();
});

// <!-- tvScientific Add to Cart Pixel -->
// window.addEventListener('updated.ecomify.cart', () => {
//     (function (j) {
//         var l='tvscientific-pix-o-37ddd834-a6c5-4717-a18f-b5c79b7833f7', s, d, w, e = encodeURIComponent, d = document, w = window.location, p = d.createElement("IMG");
//         s = w.protocol + '//tvspix.com/t.png?t=' + (new Date()).getTime() + '&l=' + l + '&u3=' + e(w.href) + '&u1=add_to_cart&u4=' + (new Date()).getTime() + '&u5=' + e(j.lastTouchChannel);
//         p.setAttribute("src", s); p.setAttribute("height", "0"); p.setAttribute("width", "0"); p.setAttribute("alt", ""); p.style.display = 'none'; p.style.position = 'fixed'; d.body.appendChild(p);
//     })({
//         lastTouchChannel: "", // optional
//     })
// })

// Summary card on the cart page - sticky on desktop
const initStickySummaryCard = () => {
  const card = document.querySelector("#cart-summary");

  if (!card) return;

  if (window.matchMedia("max-width: 991px").matches) return;

  const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0;
  const announcementBarHeight = document.querySelector('[id*="__announcement-bar"].sticky-top')?.clientHeight || 0;

  card.style.position = "sticky";
  card.style.top = `${navbarHeight + announcementBarHeight + 20}px`;
};
initStickySummaryCard();

window.addEventListener("updated.ecomify.cart", () => {
  initStickySummaryCard();
});

// Generate Shipping rates
// https://shopify.dev/docs/api/ajax/reference/cart#generate-shipping-rates
window.generateShippingRates = async (btn) => {
  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;

  const modal = document.querySelector("#shipping-rates-modal");

  modal.querySelector("#shipping-rates-modal-alert-danger").innerHTML = "";
  modal.querySelector("#shipping-rates-modal-alert-danger").setAttribute("tw:hidden", "hidden");
  modal.querySelector("#shipping-rates-modal-alert-warning").innerHTML = "";
  modal.querySelector("#shipping-rates-modal-alert-warning").setAttribute("hidden", "hidden");
  modal.querySelector("#shipping-rates-modal-alert-success").innerHTML = "";
  modal.querySelector("#shipping-rates-modal-alert-success").setAttribute("hidden", "hidden");

  const country = modal.querySelector("#shipping-rates-modal-country").value;
  const province = modal.querySelector("#shipping-rates-modal-province").value;
  const zip = modal.querySelector("#shipping-rates-modal-zip").value;

  const prepareResponse = await fetch(
    `/cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`,
    {
      method: "POST",
    },
  );

  if (prepareResponse.ok) {
    const asyncRespose = await fetch(
      `/cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`,
    );
    const data = await asyncRespose.json();

    let html = "";

    if (data.shipping_rates.length) {
      data.shipping_rates.forEach((elem) => {
        html += `
                    <li>
                        <strong>${elem.presentment_name}</strong>: ${elem.price} ${elem.currency}
                    </li>
                `;
      });

      modal.querySelector("#shipping-rates-modal-alert-success").innerHTML = `
                <ul class="ps-5 tw:mb-0">
                    ${html}
                </ul>
            `;
      modal.querySelector("#shipping-rates-modal-alert-success").removeAttribute("hidden");
    } else {
      modal.querySelector("#shipping-rates-modal-alert-warning").innerHTML = `
                <p class="tw:mb-0">
                    ${modal.dataset.textNoResults}
                </p>
            `;
      modal.querySelector("#shipping-rates-modal-alert-warning").removeAttribute("hidden");
    }
  } else {
    const data = await prepareResponse.json();
    let html = "";
    for (const [key, value] of Object.entries(data)) {
      html += `<li><strong>${key}</strong>: ${value.toString()}</li>`;
    }

    modal.querySelector("#shipping-rates-modal-alert-danger").innerHTML = `
            <ul class="ps-5 tw:mb-0">
                ${html}
            </ul>
        `;
    modal.querySelector("#shipping-rates-modal-alert-danger").removeAttribute("hidden");
  }

  btn.innerHTML = btn.dataset.text;
};

/*
    Delivery Info
*/
window.onClickCartDeliveryCollapse = (btn, event) => {
  setTimeout(() => {
    const container = document.querySelector(".rebuy-cart__flyout-content");
    container.scroll({ top: container.scrollHeight, behavior: "smooth" });
  }, 250);
};

window.openCartNoteModal = (btn, event) => {
  document.querySelector("#cart-note-modal").classList.add("show");
};

window.openCartDateModal = (btn, event) => {
  document.querySelector("#cart-date-modal").classList.add("show");
};

window.closeCartModal = (btn, event) => {
  btn.closest(".cart-delivery-modal").classList.remove("show");
};

// // Function to check if delivery selection has expired
const isDeliverySelectionExpired = (selectionTimestamp) => {
  if (!selectionTimestamp) return false;

  const selectionDate = new Date(parseInt(selectionTimestamp));
  const currentDate = new Date();
  const hoursDiff = (currentDate - selectionDate) / (1000 * 60 * 60);

  return hoursDiff > 48;
};

// Test version that expires after 30 seconds
// const isDeliverySelectionExpired = (selectionTimestamp) => {
//     if (!selectionTimestamp) return false;

//     const selectionDate = new Date(parseInt(selectionTimestamp));
//     const currentDate = new Date();
//     const secondsDiff = (currentDate - selectionDate) / 1000;

//     console.log('Time since selection:', secondsDiff, 'seconds'); // Debug log
//     return secondsDiff > 30;
// };

// Check for expired delivery selection when calendar initializes
const checkAndClearExpiredDate = async () => {
  const response = await fetch("/cart.json");
  const cart = await response.json();

  if (cart.attributes && cart.attributes.delivery_selected_at) {
    if (isDeliverySelectionExpired(cart.attributes.delivery_selected_at)) {
      // Get current cart attributes
      const cartResponse = await fetch("/cart.json");
      const cartData = await cartResponse.json();

      // Preserve all other attributes while clearing delivery ones
      const updatedAttributes = {
        ...cartData.attributes,
        delivery: "",
        delivery_selected_at: "",
      };

      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: updatedAttributes,
        }),
      });

      const selectedCell = document.querySelector(".air-datepicker-cell.-selected-");
      if (selectedCell) selectedCell.classList.remove("-selected-");
      const dateClearButton = document.getElementById("modal-date-clear-button");
      if (dateClearButton) dateClearButton.classList.add("d-none");

      // Reset the button text
      setCartDateButtonState(false);
    }
  }
};

const initCartCalender = async () => {
  checkAndClearExpiredDate();

  // Fetch the current cart to get the saved delivery date
  const cartResponse = await fetch("/cart.json");
  const cartData = await cartResponse.json();

  // Get the previously selected delivery date from cart attributes
  const savedDeliveryDate = cartData.attributes?.delivery || "";

  // Original calendar initialization with selectedDates option
  const cartDatepicker = new AirDatepicker("#cart-delivery-info-calendar", {
    locale: {
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      today: "Today",
      clear: "Clear",
    },
    inline: true,
    dateFormat: "MM/dd/yyyy",
    timeFormat: "hh:mm aa",
    firstDay: 0,
    selectedDates: savedDeliveryDate ? [new Date(savedDeliveryDate)] : [], // Set initial selection
    minDate: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000),
    onRenderCell({ date, cellType }) {
      const blockedDates = [
        // new Date(2025, 4, 26), // for a specific date in a specific year
      ];

      const recurringBlockedDates = [
        { month: 4, day: 26 }, // Memorial Day 2025
        { month: 6, day: 4 }, // Independence Day 2025
        { month: 8, day: 1 }, // Labor Day 2025
        { month: 10, day: 27 }, // Thanksgiving Day 2025
        { month: 11, day: 25 }, // Christmas Day 2025
        { month: 0, day: 1 }, // New Year's Day 2025
      ];

      const blockedRanges = [
        {
          start: new Date(2024, 11, 1), // December 1, 2024
          end: new Date(2025, 0, 14),
        },
      ];

      if (cellType === "day") {
        const dayOfWeekDisabled = date.getDay() === 6 || date.getDay() === 0;

        const isBlockedDate = blockedDates.some(
          (blockedDate) =>
            date.getFullYear() === blockedDate.getFullYear() &&
            date.getMonth() === blockedDate.getMonth() &&
            date.getDate() === blockedDate.getDate(),
        );

        const isRecurringBlockedDate = recurringBlockedDates.some(
          (blockedDate) => date.getMonth() === blockedDate.month && date.getDate() === blockedDate.day,
        );

        const isInBlockedRange = blockedRanges.some((range) => date >= range.start && date <= range.end);

        return {
          disabled: dayOfWeekDisabled || isBlockedDate || isRecurringBlockedDate || isInBlockedRange,
        };
      }
    },
    async onSelect(date, formattedDate, picker) {
      let delivery = "";
      let delivery_selected_at = "";

      if (date.formattedDate) {
        delivery = date.formattedDate;
        delivery_selected_at = Date.now().toString(); // Store selection timestamp
        // document.querySelector('#btn-cart-date-modal span').innerHTML = `Change date <span>(${date.formattedDate})</span>`;
        setCartDateButtonState(true, `Change date (${date.formattedDate})`);
      } else {
        // document.querySelector('#btn-cart-date-modal span').innerHTML = 'Schedule a future delivery';
        setCartDateButtonState(false);
      }

      const dateClearButton = document.getElementById("modal-date-clear-button");
      if (dateClearButton) dateClearButton.classList.remove("d-none");

      // Get current cart attributes
      const cartResponse = await fetch("/cart.json");
      const cartData = await cartResponse.json();

      // Preserve all other attributes while updating delivery ones
      const updatedAttributes = {
        ...cartData.attributes,
        delivery,
        delivery_selected_at,
      };

      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: updatedAttributes,
        }),
      });

      document.querySelector("#cart-date-modal")?.classList.remove("show");
    },
  });

  // Also update the button UI if there's a saved date
  if (savedDeliveryDate) {
    setCartDateButtonState(true, `Change date (${savedDeliveryDate})`);
    // document.querySelector('#btn-cart-date-modal').innerHTML = `Change date <span>(${savedDeliveryDate})</span>`;
    const dateClearButton = document.getElementById("modal-date-clear-button");
    if (dateClearButton) dateClearButton.classList.remove("d-none");
  }
};

// Make sure to await the initialization since we're making it async
(async () => {
  await initCartCalender();
})();

// window.addEventListener('updated.ecomify.cart', () => {
//     initCartCalender()
// })

window.clearCartNote = async (btn, event) => {
  // Prevent any default button behavior
  event?.preventDefault();
  setCartNoteButtonState(false);

  const wrapper = document.querySelector("#cart-delivery-wrapper .gift-note-wrapper");

  const to = wrapper.querySelector('[name="attributes[To]"]');
  const from = wrapper.querySelector('[name="attributes[From]"]');
  const message = wrapper.querySelector('[name="attributes[Message]"]');

  to.value = "";
  from.value = "";
  message.value = "";

  const attributes = {
    to: to.value,
    from: from.value,
    message: message.value,
  };

  await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      attributes,
    }),
  });

  document.querySelector("#cart-note-modal")?.classList.remove("show");
};

window.clearCartDate = async (btn, event) => {
  // Prevent any default button behavior
  event?.preventDefault();
  setCartDateButtonState(false);

  // Clear the date from the date picker
  const datepicker = document.querySelector("#cart-delivery-info-calendar");
  if (datepicker) {
    // Remove -selected- class from any previously selected date cell
    const selectedCell = document.querySelector(".air-datepicker-cell.-selected-");
    if (selectedCell) {
      selectedCell.classList.remove("-selected-");
      const dateClearButton = document.getElementById("modal-date-clear-button");
      if (dateClearButton) dateClearButton.classList.add("d-none");
    }
  }

  // Update cart attributes with empty delivery date
  await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      attributes: {
        delivery: "",
      },
    }),
  });

  // Close the modal if it's open
  document.querySelector("#cart-date-modal")?.classList.remove("show");
};

window.savePersonalizationNote = async (btn, event) => {
  event.preventDefault();

  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;

  const wrapper = btn.closest(".gift-note-wrapper");

  const to = wrapper.querySelector('[name="attributes[To]"]');
  const from = wrapper.querySelector('[name="attributes[From]"]');
  const message = wrapper.querySelector('[name="attributes[Message]"]');

  const attributes = {
    to: to.value,
    from: from.value,
    message: message.value,
  };

  await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      attributes,
    }),
  });

  if (attributes.to || attributes.from || attributes.message) {
    setCartNoteButtonState(true);
  }

  btn.innerHTML = `✓ <span class="visually-hidden">${btn.dataset.textNoteSaved}</span>`;

  setTimeout(() => {
    btn.innerHTML = btn.dataset.text;
    document.querySelector("#cart-note-modal")?.classList.remove("show");
  }, 2000);
};

window.populateGitNoteFields = () => {
  const myInterval = setInterval(() => {
    document.querySelectorAll(".gift-note-wrapper").forEach(async (wrapper) => {
      const response = await fetch("/cart.json");
      const data = await response.json();

      const to = wrapper.querySelector('[name="attributes[To]"]');
      const from = wrapper.querySelector('[name="attributes[From]"]');
      const message = wrapper.querySelector('[name="attributes[Message]"]');

      to.value = data.attributes.to ?? "";
      from.value = data.attributes.from ?? "";
      message.value = data.attributes.message ?? "";

      if (data.attributes.to || data.attributes.from || data.attributes.from) {
        setCartNoteButtonState(true);
      }

      if (data.attributes.delivery) {
        setCartDateButtonState(true, `Change date (${data.attributes.delivery})`);
        // document.querySelector('#btn-cart-date-modal span').textContent = `Change date <span>(${data.attributes.delivery})</span>`
      }

      clearInterval(myInterval);
    });
  }, 2000);
};
window.populateGitNoteFields();

// Tier Progress bars
const initTierProgressBars = () => {
  document.querySelectorAll(".tier-progress-bar").forEach((progressBar) => {
    const now = Number(progressBar.getAttribute("aria-valuenow"));
    const min = Number(progressBar.getAttribute("aria-valuemin"));
    const max = Number(progressBar.getAttribute("aria-valuemax"));

    if (now < min) {
      progressBar.style.width = "0%";
    } else {
      progressBar.style.width = (now / max) * 100 + "%";
    }

    const progressLabel = progressBar.closest(".progress").nextElementSibling;

    if (now >= max) {
      progressLabel.classList.add("progress-label-completed");
    } else {
      progressLabel.classList.remove("progress-label-completed");
    }
  });
};
initTierProgressBars();

window.addEventListener("updated.ecomify.cart", async () => {
  const res = await fetch("/cart.json");
  const data = await res.json();

  document.querySelectorAll(".tier-progress-bar").forEach((progressBar) => {
    progressBar.setAttribute("aria-valuenow", data.total_price);
  });
  initTierProgressBars();

  // Update navbar cart total price
  updateCartTotalPrice(data);
});
